import React, { useState } from 'react';
import api from '../utils/api';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

const ExportButton = ({ endpoint, filename, label = 'Export Excel' }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await api.get(endpoint, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'export.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('Export failed');
    } finally { setExporting(false); }
  };

  return (
    <button onClick={handleExport} className="btn btn-secondary btn-sm" disabled={exporting} data-testid="export-btn">
      <Download size={14} /> {exporting ? 'Exporting...' : label}
    </button>
  );
};

export default ExportButton;
